import api from 'api'
import { ImpressaoAcompanhamentoMChatInput } from 'api/ImpressaoMChat'
import { defaultHandleError } from 'util/downloadFile'
import { previewFile } from 'util/previewFile'

export const downloadMChat = async (input: ImpressaoAcompanhamentoMChatInput) => {
  return await api.mchat
    .imprimirMChat(input)
    .then((response) => {
      previewFile(new Blob([response.data], { type: 'application/pdf' }), `MChat_${new Date().getTime()}.pdf`)
      return response
    })
    .catch(defaultHandleError)
}
